import React, { useEffect, useState } from "react";
import { ArrowLeftRight, ReceiptCutoff, Coin } from "react-bootstrap-icons";

const numberFormatter = new Intl.NumberFormat();
const moneyFormater = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "PGK"
});

export function DailyStatistics ({className, dailyStats}){
    
    const [ transaction, setTransaction] = useState(0);
    const [ revenue, setRevenue] = useState(0);
    const [ receipts, setReceipts] = useState(0);

    useEffect(() => {
        if (Array.isArray(dailyStats) && dailyStats.length > 0){
            setTransaction(dailyStats[0].transaction);
            setRevenue(dailyStats[0].revenue);
            setReceipts(dailyStats[0].transaction);
        }
    }, [dailyStats]);

    return (
        <div className={`card card-custom ${className}`} >
            {/* Header */}
            <div className="card-header border-0 pt-5">
                <h3 className="card-title font-weight-bolder ">Daily Statistics</h3>
            </div>
            {/* Body */}
            <div className="row">
                <div className="col">
                    <div className="row-4"> 
                        <TotalDailyTransaction totalTx={transaction} />
                    </div>
                    <br/>
                    <div className="row-4">
                        <DailyPayments totalRevenue={revenue} />
                    </div>
                    <br/>
                    <div className="row-4">
                        <ReceiptsCollected totalReceipts={receipts} />
                    </div>
                </div>
            </div>
        </div>
    )
};

function TotalDailyTransaction ({ totalTx }){
    return (
        <div className="container">
            <div className="row d-flex justify-content-center text-center">
                <div className="col-4">
                    <div className="row-12"> 
                        <ArrowLeftRight size={50} /> 
                    </div>
                </div>
                <div className="col-8">
                    <div className="row-6"> 
                        <span className="font-size-h5 font-weight-bolder"> {numberFormatter.format(totalTx)} </span>
                    </div>
                    <hr/>
                    <div className="row-6">
                        <span> Total Daily Transactions </span>
                    </div>
                </div>
            </div>
        </div>
    )
};

function DailyPayments ({ totalRevenue }){
    return (
        <div className="container">
            <div className="row d-flex justify-content-center text-center">
                <div className="col-4">
                    <div className="row-12"> 
                        <Coin size={50} /> 
                    </div>
                </div>
                <div className="col-8">
                    <div className="row-6"> 
                        <span className="font-size-h5 font-weight-bolder">{moneyFormater.format(totalRevenue)}</span> 
                    </div>
                    <hr/>
                    <div className="row-6">
                        <span> Total Payments Today </span>
                    </div>
                </div>
            </div>
        </div>
    )
};

function ReceiptsCollected ({ totalReceipts }){
    return (
        <div className="container">
            <div className="row d-flex justify-content-center text-center">
                <div className="col-4">
                    <div className="row-12"> 
                        <ReceiptCutoff size={50} /> 
                    </div>
                </div>
                <div className="col-8">
                    <div className="row-6"> 
                        <span className="font-size-h5 font-weight-bolder">{totalReceipts}</span>
                    </div>
                    <hr/>
                    <div className="row-6">
                        <span> Receipts Processed </span>
                    </div>
                </div>
            </div>
        </div>
    )
};